<template>
    <div>
      <div>
        <a-button v-if="!isEdit" type="primary" @click="isEdit=true">编辑</a-button>
        <template v-else>
          <a-button type="primary" @click="add">添加</a-button>
        </template>
      </div>
      <div>
        <a-table
          ref="table"
          bordered
          size="middle"
          rowKey="id"
          :columns="columns"
          :dataSource="tableFormInputArray"
          :pagination="false"
        >
          <span slot="action" slot-scope="text, record,index" v-if="isEdit">
            <a @click="handleEdit(record,index)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm   title="确定删除吗?" @confirm="() =>handleDelete(index)">
            <a>删除</a>
          </a-popconfirm>
        </span>
          <div slot="formItemList" slot-scope="text, record,index">
            <div v-for="(item,index) in record.formItemList" :key="index">
              {{item.number || ''}}{{item.name}}
            </div>
        </div>
        </a-table>
        <template v-if="isEdit">
          <a-button type="primary" @click="cancel">取消</a-button>
          <a-button type="primary" style="margin-left: 10px" @click="save">保存</a-button>
        </template>
      </div>
      <a-modal
        title="选择表单题目"
        :width="1000"
        :visible="visible"
        @ok="handleOk"
        @cancel="handleCancel">
        <a-spin :spinning="confirmLoading">
          <a-form-model layout="horizontal" :model="formModal" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 18 },}" ref="ruleForm" :rules="rules">
            <a-form-model-item
              prop="formId"
              label="表单">
              <a-select
                placeholder="请选择"
                v-model="formModal.formId"
                showSearch
                :filterOption="filterOption"
                @change="formIdChange"
              >
                <a-select-option :value="item.id" v-for="item in formList">{{item.name}}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              label="是否反向表情"
            help="正向：不悦...悦（不同意...非常同意）；反向：悦...不悦（非常同意...不同意）">
              <a-radio-group  v-model="formModal.reverse" >
                <a-radio-button value="0">
                  否
                </a-radio-button>
                <a-radio-button value="1">
                  是
                </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item
              prop="formItemIdList"
              label="表单题目">
              <a-select
                mode="multiple"
                placeholder="请选择"
                v-model="formModal.formItemIdList"
                showSearch
                :filterOption="filterOption"
                @change="formItemIdChange"
              >
                <a-select-option :value="item.id" v-for="item in formItemList">{{item.name}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model>
        </a-spin>
      </a-modal>
    </div>
</template>

<script>
  import baseRules from '@/constants/baseRules'
  import { getAction,postAction } from '@/api/manage'
  import Vue from 'vue'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  export default {
    name: 'TableFormInput',
    props:{
      tableFormInput:{
        type:String,
        default:''
      }
    },
    data() {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        isEdit:false,
        tableFormInputArray:[],
        visible:false,
        confirmLoading:false,
        formModal:{},
        formList:[],
        formItemList:[],
        editIndex:-1,
        rules:{
          formId:[baseRules.requiredChange],
          formItemIdList:[baseRules.requiredChange],
        },
        columns: [

          {
            title: '表单',
            align: "center",
            width: 200,
            ellipsis: true, //表格省略
            dataIndex: 'formName',
          },
          {
            title: '反向表情',
            align: "center",
            width: 100,
            dataIndex: 'reverse',
            customRender:(text)=>{
              return text==='1'?'是':'否'
            }
          },
          {
            title: '题目',
            ellipsis: true, //表格省略
            align: "center",
            dataIndex: 'formItemList',
            scopedSlots: {customRender: 'formItemList'},
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 100
          }
        ]
      }
    },
    watch:{
      tableFormInput(){
        this.initData()
      }
    },
    mounted(){
      this.initData()
    },
    methods:{
      handleEdit(record,index){
        this.editIndex=index
        this.edit(record)
      },
      initData(){
        this.tableFormInputArray = this.tableFormInput?JSON.parse(this.tableFormInput):[]
      },
      add(){
        this.editIndex=-1
        this.edit({
          formId:'',
          formName:'',
          formItemList:[],
          reverse:'0'
        })
      },
      edit(model){
        const formModal = JSON.parse(JSON.stringify(model))
        formModal.formItemIdList = []
        formModal.formItemList.forEach(item=>{
          formModal.formItemIdList.push(item.id)
        })
        this.formModal=formModal
        if(this.formModal.formId){
          this.confirmLoading = true
          getAction('/project/projectFormItem/listAll',{formId:this.formModal.formId,scale:'0'}).then(res=>{
            if(res.success){
              this.formItemList = res.result
            }
          }).finally(()=>{
            this.confirmLoading = false
          })
        }
        this.confirmLoading = true
        getAction('/project/projectForm/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.formList=res.result
            this.visible = true
          }
        }).finally(()=>{
          this.confirmLoading = false
        })
      },
      formIdChange(){
        this.formModal.formItemList = []
        this.confirmLoading = true
        if(this.formModal.formId){
          getAction('/project/projectFormItem/listAll',{formId:this.formModal.formId,scale:'0'}).then(res=>{
            if(res.success){
              this.formItemList = res.result
            }
          }).finally(()=>{
            this.confirmLoading = false
          })
          this.formList.forEach(item=>{
            if(item.id===this.formModal.formId){
              this.formModal.formName = item.name
            }
          })
        }else{
          this.formItemList = []
        }
      },
      formItemIdChange(){
        let error = false
        let lastElementId = null
        this.formItemList.forEach(formItem=>{
          if(error){
            return
          }
          this.formModal.formItemIdList.forEach(itemId=>{
            if(error){
              return
            }
            if(itemId===formItem.id){
              if(lastElementId==null){
                lastElementId = formItem.element.id
              }else{
                if(lastElementId != formItem.element.id){
                  error = true
                }
              }
            }
          })
        })
        if(error){
          this.$message.warning('请选择相同答案的表单题目')
        }
      },
      cancel(){
        this.initData()
        this.visible = false
        this.isEdit = false
      },
      handleDelete(index){
        this.tableFormInputArray.splice(index,1)
      },
      save(){
        this.$emit('onsubmit',JSON.stringify(this.tableFormInputArray))
        this.cancel()
      },
      getNameList(dictItemList){
        if(!dictItemList && dictItemList.length>0){
          return ''
        }
        const arrays = []
        // const dictItemList = JSON.parse(dictItems)
        dictItemList.forEach(item=>{
          arrays.push(item.text)
        })
        return arrays.toString()
      },
      handleOk(){
        const formItemList = []
        this.formItemList.forEach(formItem=>{
          this.formModal.formItemIdList.forEach(itemId=>{
            if(itemId===formItem.id){
              formItemList.push({
                id:itemId,
                name:formItem.name,
                number:formItem.number
              })
            }
          })
        })
        let error = false
        let lastElementId = null
        this.formItemList.forEach(formItem=>{
          if(error){
            return
          }
          this.formModal.formItemIdList.forEach(itemId=>{
            if(error){
              return
            }
            if(itemId===formItem.id){
              if(lastElementId==null){
                lastElementId = formItem.element.id
              }else{
                if(lastElementId != formItem.element.id){
                  error = true
                }
              }
            }
          })
        })
        if(error){
          return this.$message.warning('请选择相同答案的表单题目')
        }
        delete this.formModal.formItemIdList
        this.formModal.formItemList = formItemList
        if(this.editIndex>=0){
          this.tableFormInputArray.splice(this.editIndex,1,JSON.parse(JSON.stringify(this.formModal)))
        }else{
          this.tableFormInputArray.push(JSON.parse(JSON.stringify(this.formModal)))
        }
        this.handleCancel()
      },
      handleCancel(){
        this.visible = false
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

    }
  }
</script>

<style scoped>

</style>